module.exports = __webpack_public_path__ + "img/forest.7a4064ba.webp";